module.exports = __webpack_public_path__ + "img/directbox-receive.90acc8e0.svg";